import { useEffect, useMemo, useState } from 'react'
import debounce from 'lodash.debounce'
import { TextField } from '@mui/material'

type POInstructionsFieldProps = {
  /** Leave out when a heading next to the field already names it. */
  label?: string
  /** Names the field for screen readers when there is no `label`. */
  ariaLabel?: string
  value: string
  onChange: (next: string) => void
  helperText?: string
}

export default function POInstructionsField({
  label,
  ariaLabel,
  value,
  onChange,
  helperText,
}: POInstructionsFieldProps) {
  const [internal, setInternal] = useState(value)

  useEffect(() => {
    setInternal(value)
  }, [value])

  const debouncedOnChange = useMemo(
    () => debounce((next: string) => onChange(next), 500),
    [onChange],
  )

  useEffect(() => {
    return () => {
      debouncedOnChange.flush()
    }
  }, [debouncedOnChange])

  return (
    <TextField
      variant="outlined"
      fullWidth
      multiline
      minRows={4}
      label={label}
      value={internal}
      helperText={helperText}
      onChange={(e) => {
        setInternal(e.target.value)
        debouncedOnChange(e.target.value)
      }}
      slotProps={{
        inputLabel: { shrink: true },
        htmlInput: { 'aria-label': label ? undefined : ariaLabel },
      }}
    />
  )
}
